module.exports = __webpack_public_path__ + "static/media/jedi-order.db55ad9d.svg";